/* 
 * NOTICE OF LICENSE
 * 
 * This source file is subject to the Academic Free License (AFL 3.0)
 * 
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2019 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */

import $ from 'jquery';

( function() {
    
    $('.js-menu-btn').on('click', function (e){
        e.preventDefault();
        if( $(this).hasClass('opened') ){
            $(this).removeClass('opened');
            $('.js-main-nav').removeClass('opened');
            $('.js-nav-over').removeClass('opened');
        }else{
            $(this).addClass('opened');
            $('.js-main-nav').addClass('opened');
            $('.js-nav-over').addClass('opened');
        }
    });

    $(document).on('click', '.js-nav-over', function (e){
        e.stopPropagation();
        $('.js-menu-btn').removeClass('opened');
        $('.js-main-nav').removeClass('opened');
        $('.js-nav-over').removeClass('opened');
    });

    $('#main-navigation > ul > li.menu-item-has-children > a').on('click', function (e){
        var _xx = $(window).width();
        if( _xx >= 992 ){ return ; }
        e.preventDefault();
        $(this).parents('.menu-item-has-children').toggleClass('open--link');
        $(this).parents('.menu-item-has-children').find('.sub-menu').first().slideToggle();
    });
    $('.js-back-btn').on('click', function (e){
        e.preventDefault();
        history.back();
    });
    
} )();